<div class="disclaimer">
  <div class="disclaimer-links d-flex flex-row">
    <a href="/doc/privacy" target="_blank">Privacy Policy</a>
    <span class="mx-1">|</span>
    <a href="/doc/terms" target="_blank">Terms of Use</a>
  </div>
  <span>{{ data?.copyright }}</span>
</div>
